<template>
    <div>
        <el-tag :key="tag" v-for="tag in dynamicTags" closable :disable-transitions="false" @close="handleClose(tag)">
            {{ tag }}
        </el-tag>
        <el-input
            class="input-new-tag"
            v-if="inputVisible"
            v-model="inputValue"
            ref="saveTagInput"
            size="small"
            @keyup.enter.native="handleInputConfirm"
            @blur="handleInputConfirm"
        >
        </el-input>
        <el-button v-else class="button-new-tag" size="small" @click="showInput" icon="el-icon-plus"></el-button>
    </div>
</template>
<script>
export default {
    props: {
        value: {
            type: Array,
            default: () => [],
        },
    },
    watch: {
        value: {
            handler(val) {
                this.dynamicTags = val || [];
            },
            immediate: true,
        },
    },
    data() {
        return {
            dynamicTags: [],
            inputVisible: false,
            inputValue: "",
        };
    },
    methods: {
        handleClose(tag) {
            this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
            this.$emit("input", this.dynamicTags);
            this.$emit("change", this.dynamicTags);
        },

        showInput() {
            this.inputVisible = true;
            this.$nextTick(() => {
                this.$refs.saveTagInput.$refs.input.focus();
            });
        },

        handleInputConfirm() {
            let inputValue = this.inputValue;
            if (inputValue) {
                this.dynamicTags.push(inputValue);
            }
            this.inputVisible = false;
            this.inputValue = "";
            this.$emit("input", this.dynamicTags);
            this.$emit("change", this.dynamicTags);
        },
    },
};
</script>
<style>
.el-tag {
    margin-right: 10px;
}
.button-new-tag {
    margin-right: 10px;
    height: 32px;
    line-height: 30px;
    padding-top: 0;
    padding-bottom: 0;
}
.input-new-tag {
    width: 90px;
    margin-right: 10px;
    vertical-align: bottom;
}
</style>
